import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "btn-group d-none d-md-flex justify-content-center"
}
const _hoisted_2 = {
  key: 1,
  class: "dropdown d-md-none"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "bi-chevron-down" })
], -1)
const _hoisted_4 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", null, [
    (!_ctx.isSmallScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectTemplates, (_objectTemplate, key, index) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(_objectTemplate.Region, _objectTemplate.ObjectEnum)), {
              key: `${ key }-${ index }-${ Math.random().toString(36).slice(2, 7) }`,
              object: _objectTemplate
            }, null, 8, ["object"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSmallScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectTemplates, (_objectTemplate, key, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${ key }-${ index }-${ Math.random().toString(36).slice(2, 7) }-'li'`,
                class: "dropdown-item btn-group justify-content-center"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(_objectTemplate.Region, _objectTemplate.ObjectEnum)), {
                  key: `${ key }-${ index }-${ Math.random().toString(36).slice(2, 7) }`,
                  object: _objectTemplate
                }, null, 8, ["object"]))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}